function normalizeRequiredText(value, fieldName) {
	const normalized = value === undefined || value === null ? "" : String(value).trim();
	if (!normalized) {
		throw new Error(`Unable to delete status item without ${fieldName}.`);
	}
	return normalized;
}

export function buildStatusDeleteRequest({
	isAdministrator = false,
	orgId,
	instanceId,
	url
} = {}) {
	if (!isAdministrator) {
		throw new Error("Only organization administrators can delete status items.");
	}

	const normalizedOrgId = normalizeRequiredText(orgId, "an organization ID");
	const normalizedInstanceId = normalizeRequiredText(instanceId, "an instance ID");
	const normalizedUrl = normalizeRequiredText(url, "a storage URL");
	const expectedSuffix = `_${normalizedInstanceId}.json`;

	if (!normalizedUrl.endsWith(expectedSuffix)) {
		throw new Error("The selected status item storage URL does not match its instance ID.");
	}

	return {
		orgId: normalizedOrgId,
		instanceId: normalizedInstanceId,
		url: normalizedUrl
	};
}

export function getStatusDeleteErrorMessage(error) {
	const responseBody = error && error.response && error.response.body;
	if (responseBody && responseBody.message) {
		return responseBody.message;
	}
	if (error && error.message) {
		return error.message;
	}
	return String(error || "Unknown error");
}
